<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Confirmation</h3>
      </v-flex>

      <v-flex lg12>
        <v-card>
          <v-card-text>
            <v-layout row wrap>

              <v-flex class="px-2 py-0" xs12>
                <v-alert
                    class="mb-6"
                    outlined
                    type="info">
                  <strong> Total Trekking Cost (USD): $ {{ calculateTrekkingPermitCharge() }}
                    {{ trekkingData.exemption.amount ? ' with exemption claim' : '' }}</strong>
                </v-alert>
              </v-flex>

              <confirmation-header-text class="ml-2" icon="mdi-alpha-t-box"
                                        text="Trekking Route"/>

              <v-flex md4 xs6>
                <list-item-detail :sub_title="trekkingData.trekkingRoute.name"
                                  title="Trekking Route"/>
              </v-flex>

              <v-flex md4 xs6>
                <list-item-detail :sub_title="trekkingData.no_of_days"
                                  title="Number Of Days"/>
              </v-flex>

              <v-flex md4 xs6>
                <list-item-detail :sub_title="trekkingData.starting_date"
                                  title="Starting Date"/>
              </v-flex>


              <v-flex xs12>
                <v-divider class="my-3"/>
              </v-flex>

              <confirmation-header-text class="ml-2" icon="mdi-account"
                                        text="Trekker's Info:"/>


              <template v-for="(trekker, i) in trekkingData.trekkers">
                <v-flex :key="i+'a'" md3 xs6>
                  <list-item-detail :sub_title="trekker.name"
                                    title="Full Name"/>
                </v-flex>
                <v-flex :key="i+'b'" md3 xs6>
                  <list-item-detail :sub_title="trekker.country"
                                    title="Country"/>
                </v-flex>
                <v-flex :key="i+'c'" md3 xs6 v-if="!trekker.indian_without_visa">
                  <list-item-detail :sub_title="trekker.visa_number.toUpperCase()"
                                    title="Visa Number/Submission Number"/>
                </v-flex>
                <v-flex :key="i+'c'" md3 xs6>
                  <list-item-detail :sub_title="trekker.dob"
                                    title="Date of birth"
                  />
                </v-flex>
                <v-flex :key="i+'d'" md3 xs12>
                  <list-item-detail :sub_title="trekker.passport_number.toUpperCase()"
                                    title="Document Number"/>
                </v-flex>
                <v-flex :key="i+'d'" md3 xs12>
                  <list-item-detail
                      :sub_title="(trekker.isFree || (getAge(trekker.dob) < 10 && trekker.country != 'United States of America (USA)')) ? 'Yes':'No'"
                      title="Is Free?"/>
                </v-flex>

                <v-flex xs12>
                  <v-divider class="my-3"/>
                </v-flex>

              </template>

              <v-flex xs6 v-if="trekkingData.exemption.file" ml-4>
                <v-list-item-subtitle style="font-size: 12px;user-select: text;">Exemption Document
                  File
                </v-list-item-subtitle>
                <file-display :src="trekkingData.exemption.file" :avatar="true"/>
              </v-flex>

              <v-flex xs5 v-if="trekkingData.exemption.amount">
                <list-item-detail :sub_title="trekkingData.exemption.amount"
                                  title="Exemption Amount"/>
              </v-flex>

              <v-flex xs12 v-if="trekkingData.exemption.file">
                <v-divider class="my-3"/>
              </v-flex>

              <confirmation-header-text class="ml-0" icon="mdi-account"
                                        text="Nepali Guide Info:"/>


              <v-flex md3 xs6>
                <list-item-detail :sub_title="trekkingData.nepaliGuide.name"
                                  title="Full Name"/>
              </v-flex>

              <v-flex md3 xs6>
                <list-item-detail :sub_title="trekkingData.nepaliGuide.mobile_number"
                                  title="Mobile Number"/>
              </v-flex>

              <v-flex md3 xs6>
                <list-item-detail :sub_title="trekkingData.nepaliGuide.citizenship_number"
                                  title="Citizenship No"/>
              </v-flex>

              <v-flex md3 xs6>
                <v-list-item-subtitle style="font-size: 12px;user-select: text;">Insurance File
                </v-list-item-subtitle>
                <file-display :src="trekkingData.nepaliGuide.file" :avatar="true"/>
              </v-flex>

              <v-flex xs12>
                <v-divider class="my-3"/>
              </v-flex>

              <confirmation-header-text class="ml-0" icon="mdi-account"
                                        v-if="trekkingData.porter.length > 0"
                                        text="Porter's Info:"/>

              <template v-for="(porter,i) in trekkingData.porter">
                <v-flex :key="'p'+porter.id" md4 xs6>
                  <list-item-detail :sub_title="porter.name"
                                    title="Full Name"/>
                </v-flex>

                <v-flex :key="'q'+porter.id" md4 xs6>
                  <list-item-detail :sub_title="porter.mobile_number"
                                    title="Mobile Number"/>
                </v-flex>

                <v-flex :key="'r'+porter.id" md4 xs6>
                  <list-item-detail :sub_title="porter.citizenship_number"
                                    title="Citizenship No"/>
                </v-flex>

              </template>
              <confirmation-header-text v-if="trekkingData && trekkingData.staff_insurance" class="ml-0"
                                        icon="mdi-alpha-t-box"
                                        text="Staff Insurance File"/>
              <template v-if="trekkingData && trekkingData.staff_insurance">
                <v-flex md3 xs6 class="ml-2">
                  <file-display :src="trekkingData.staff_insurance" :avatar="true"/>
                </v-flex>
              </template>
            </v-layout>
          </v-card-text>
          <v-flex xs12 v-if="trekkingData.porter.length > 0">
            <v-divider class="my-3"/>
          </v-flex>
          <v-card-actions class="pb-3">
            <v-spacer/>
            <v-btn :disabled="loading" @click="$router.go(-1)" color="green lighten-6" dark>
              Go Back
            </v-btn>
            <v-btn :loading="loading" @click="confirm" color="blue darken-2" dark>
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped>

.section-header {
  border-bottom: 1px solid #505656c2;
  font-size: 1.5em;
  font-weight: 400;
}

.value {
  font-weight: normal;
  font-size: 1.2em;
}

</style>
<script>
import {mapActions, mapGetters} from "vuex";
import ListItemDetail from '../../components/ListItemDetail'
import FileDisplay from '../../components/FileDisplay'
import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
import moment from "moment";
import _ from "lodash"

export default {
  components: {ConfirmationHeaderText, ListItemDetail, FileDisplay},
  data() {
    return {
      errors: [],
      // porterInsurance: 'https://picsum.photos/200/300',
      porterInsurance: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters("TrekkingSingle", ["trekkingData", "loading", "newRequestMade"])
  },
  methods: {
    ...mapActions("TrekkingSingle", ["resetState", "createTrekkingRequest"]),
    calculateTrekkingPermitCharge() {
      let totalCost = 0;
      var self = this;
      if (this.trekkingData.isExpedition && this.trekkingData.trekkingRoute && ![1, 2].includes(this.trekkingData.trekkingRoute.id)) {
        return 0;
      }
      let countPricing = this.trekkingData.trekkingRoute.extra.pricing.length;
      let appliedDays = this.trekkingData.no_of_days;
      let trekkingPackage = this.trekkingData.trekkingRoute.min_days;

      if (countPricing === 1) {
        let trekkingPackagePricing = this.trekkingData.trekkingRoute.extra.pricing[0];
        totalCost = this.simpleCaseCostCalculation(appliedDays, trekkingPackage, trekkingPackagePricing)
      } else {
        let trekkingDate = this.trekkingData.starting_date;
        let trekkingUptoDate = moment(trekkingDate).add(appliedDays, 'days').subtract(1, 'days').format('Y-MM-DD');
        let trekkingDateMonth = moment(trekkingDate).format('MM');
        let trekkingUptoDateMonth = moment(trekkingUptoDate).format('MM');

        // let totalDaysInAppliedMonth = moment(trekkingDate, "YYYY-MM").daysInMonth();
        // let endOfAppliedDate = moment(this.trekkingData.starting_date).endOf('month');
        // let remainingDaysInAppliedDate = endOfAppliedDate.diff(moment(this.trekkingData.starting_date), 'days')
        let sameRequestPackage = null;
        if (trekkingDateMonth != trekkingUptoDateMonth) {
          sameRequestPackage = this.trekkingData.trekkingRoute.extra.pricing.find(function (p) {
            if (p.from_month < p.to_month) {
              if ((p.from_month <= parseInt(trekkingDateMonth) && parseInt(trekkingUptoDateMonth) <= p.to_month))
                return true;
            } else {
              if ((p.from_month >= parseInt(trekkingDateMonth) && parseInt(trekkingUptoDateMonth) <= p.to_month))
                return true;
            }
            return false;
          });
        } else {
          let allMonths = [];
          let firstPackageAllMonths = [];
          let secondPackageAllMonths = [];
          this.trekkingData.trekkingRoute.extra.pricing.forEach(function (p) {
            if (p.from_month == 12 && !firstPackageAllMonths.length) {
              firstPackageAllMonths.push(12);
              for (var i = 1; i <= parseInt(p.to_month); i++) {
                firstPackageAllMonths.push((parseInt(i)));
              }
            } else {
              if (!secondPackageAllMonths.length) {
                for (var j = parseInt(p.from_month); j <= parseInt(p.to_month); j++) {
                  secondPackageAllMonths.push((parseInt(j)));
                }
              }
            }
          });
          sameRequestPackage = this.trekkingData.trekkingRoute.extra.pricing.find(function (p) {
            return firstPackageAllMonths.includes(p.from_month) || firstPackageAllMonths.includes(p.to_month)
          });
          if (!sameRequestPackage) {
            sameRequestPackage = this.trekkingData.trekkingRoute.extra.pricing.find(function (p) {
              return secondPackageAllMonths.includes(p.from_month) || secondPackageAllMonths.includes(p.to_month)
            });
          }
        }
        if (!sameRequestPackage) {
          let maxPricingPackage = this.trekkingData.trekkingRoute.extra.pricing.reduce((max, obj) => (parseInt(max.min_days_rate) > parseInt(obj.min_days_rate)) ? max : obj);
          let extendRatePackage = this.trekkingData.trekkingRoute.extra.pricing.find(function (p) {
            if (p.from_month < p.to_month) {
              if ((p.from_month <= parseInt(trekkingUptoDateMonth)) && (p.to_month >= parseInt(trekkingUptoDateMonth)))
                return true;
            } else {
              if ((p.from_month <= parseInt(trekkingUptoDateMonth)) || parseInt(trekkingUptoDateMonth) <= p.to_month)
                return true;
            }
            return false;
          });
          if (this.trekkingData.isExtension) {
            if (maxPricingPackage.extend_as_week) {
              totalCost += parseInt(Math.ceil(appliedDays / 7)) * (parseInt(extendRatePackage.extend_per_day));
            } else {
              totalCost += parseInt(appliedDays) * (parseInt(extendRatePackage.extend_per_day));
            }
          } else {
            if (maxPricingPackage.week) {
              let extraDays = 0;
              if (appliedDays > parseInt(maxPricingPackage.week) * 7) {
                extraDays = appliedDays - (parseInt(maxPricingPackage.week) * 7)
              }
              let calculatedWeek = Math.ceil((appliedDays - extraDays) / 7);
              totalCost += calculatedWeek * parseInt(maxPricingPackage.min_days_rate);
              if (maxPricingPackage.extend_as_week) {
                if (parseInt(extraDays) > 0) {
                  totalCost += parseInt(Math.ceil(extraDays / 7)) * (parseInt(extendRatePackage.extend_per_day));
                }
              } else {
                if (parseInt(extraDays) > 0) {
                  totalCost += parseInt(extraDays) * (parseInt(extendRatePackage.extend_per_day));
                }
              }
            } else {
              let extraDays = appliedDays - trekkingPackage;
              totalCost += parseInt(maxPricingPackage.min_days_rate);
              if (parseInt(extraDays) > 0) {
                totalCost += parseInt(extraDays) * (parseInt(extendRatePackage.extend_per_day));
              }
            }
          }
        } else {
          totalCost = this.simpleCaseCostCalculation(appliedDays, trekkingPackage, sameRequestPackage)
        }
      }

      let freeTrekkers = self.trekkingData.trekkers.filter(item => {
        return item.isFree || (moment().diff(item.dob, 'years', false) < 10 && item.country != 'United States of America (USA)');
      });
      return totalCost * (self.trekkingData.trekkers.length - freeTrekkers.length);
    },
    simpleCaseCostCalculation(appliedDays, trekkingPackage, trekkingPackagePricing) {
      let totalCost = 0;
      if (trekkingPackagePricing.week) {
        if (this.trekkingData.isExtension) {
          if (trekkingPackagePricing.extend_as_week) {
            totalCost += parseInt(Math.ceil(appliedDays / 7)) * (parseInt(trekkingPackagePricing.extend_per_day));

          } else {
            totalCost += parseInt(appliedDays) * (parseInt(trekkingPackagePricing.extend_per_day));

          }
        } else {
          let extraDays = 0;
          if (appliedDays > parseInt(trekkingPackagePricing.week) * 7) {
            extraDays = appliedDays - (parseInt(trekkingPackagePricing.week) * 7)
          }
          let calculatedWeek = Math.ceil((appliedDays - extraDays) / 7);

          totalCost += calculatedWeek * parseInt(trekkingPackagePricing.min_days_rate);
          if (trekkingPackagePricing.extend_as_week) {
            if (parseInt(extraDays) > 0) {
              totalCost += parseInt(Math.ceil(extraDays / 7)) * (parseInt(trekkingPackagePricing.extend_per_day));
            }
          } else {
            if (parseInt(extraDays) > 0) {
              totalCost += parseInt(extraDays) * (parseInt(trekkingPackagePricing.extend_per_day));
            }
          }
        }
      } else {
        if (this.trekkingData.isExtension) {
          totalCost += parseInt(appliedDays) * (parseInt(trekkingPackagePricing.extend_per_day))
        } else {
          let extraDays = appliedDays - trekkingPackage;
          totalCost += parseInt(trekkingPackagePricing.min_days_rate);
          if (parseInt(extraDays) > 0) {
            totalCost += parseInt(extraDays) * (parseInt(trekkingPackagePricing.extend_per_day));
          }
        }
      }
      return totalCost;
    },
    confirm() {
      this.loading = true;
      this.createTrekkingRequest()
          .then(() => {
            this.$store.commit('Notification/showSuccess', 'Trekking Request received successfully');
            this.$router.push({
              name: 'TrekkingRequestPrint'
            })
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getAge(dob) {
      return moment().diff(dob, 'years', false)

    }

  },
  mounted() {
    // if(!this.trekkingData.trekkers) {
    //     return this.$router.push({
    //         name: 'TrekkingRequestNew'
    //     });
    // } else {


    // }
  },
  created() {
    if (!this.newRequestMade) {
      this.$router.replace({name: 'TrekkingRequestNew'});
    }

  }
};
</script>
